export default "__VITE_ASSET__L2VX0aFA__"